import { AestheticMedicineExperience } from "./v1";

export const aestheticMedicineExperienceOptions = Object.entries(AestheticMedicineExperience)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
